var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaDecidiTu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fh2bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 24.27h9.965v10.359H10z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fh2bc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.34 6.55h20.298v6.495H10.34z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#67a2ad",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M24.45 14.84c.154.395.457.796.44 1.183-.108 2.382-.935 4.51-2.606 6.227-1.23 1.264-2.371 1.255-3.595-.02-1.708-1.775-2.49-3.981-2.599-6.413-.015-.322.403-.663.743-.909-.718 1.994 1.148 6.774 3.056 7.498.347.132.817.149 1.168.032 1.931-.645 3.834-5.49 2.949-7.421l.444-.177"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fh2bb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M10 31.613s1.573-6.031 4.983-6.556c0 0 1.573-.808 3.67-.787 0 0-.436 2.842 1.312 4.852v5.507s-6.818-.087-9.965-3.016"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M30.974 31.613s-1.573-6.031-4.982-6.556c0 0-1.573-.808-3.67-.787 0 0 .437 2.842-1.312 4.852v5.507s6.818-.087 9.964-3.016"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M20.265 24.99l-1.245-.72v1.438z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M20.71 24.99l1.245-.72v1.438z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M20.491 28.777l.462-1.245-.079-2.022h-.767l-.077 2.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M25.139 14.093H15.91c-.438-2.436-.186-2.788 2.573-2.945a35.178 35.178 0 0 1 3.966-.004c2.859.161 2.951.303 2.689 2.95"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fh2bc)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M18.295 10.7c1.443-.09 2.9-.096 4.342-.005 2.672.167 3.136.317 3.036 2.35l4.965-2.165-10.05-4.33-10.248 4.33 4.974 2.127c-.148-1.824.458-2.149 2.981-2.307"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M27.816 22.438a.263.263 0 0 1-.262-.262V11.512a.262.262 0 0 1 .525 0v10.664a.263.263 0 0 1-.263.262"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M28.354 19.547a.537.537 0 1 0-1.074 0 .537.537 0 0 0 1.074 0"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaDecidiTu);
export default __webpack_public_path__ + "static/media/IconaDecidiTu.651be6b1216266f2351a31d104eece69.svg";
export { ForwardRef as ReactComponent };